import React, { Component } from 'react';
import PropTypes from 'prop-types';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_dot_button__Mpo-M {\n  cursor: pointer;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  padding: 0px;\n  background: black;\n  color: white;\n  border: 2px solid black;\n  text-align: center;\n  font: 23px Arial, sans-serif;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.styles_dot_button__Mpo-M:hover {\n  background-color: grey;\n  border: gray;\n}\n\n.styles_dot_button__Mpo-M:focus {\n  outline: 1px dotted;\n}\n\n.styles_dot_button__Mpo-M:disabled {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n";
var styles = { "dot_button": "styles_dot_button__Mpo-M" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var SwitchTextSize = function (_Component) {
  inherits(SwitchTextSize, _Component);

  function SwitchTextSize(props) {
    classCallCheck(this, SwitchTextSize);

    var _this = possibleConstructorReturn(this, (SwitchTextSize.__proto__ || Object.getPrototypeOf(SwitchTextSize)).call(this, props));

    _this.state = {
      font_size: props.default
    };

    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  createClass(SwitchTextSize, [{
    key: "getTextSize",
    value: function getTextSize() {
      var font_size = void 0;
      if (this.props.store && this.props.store.getItem(this.props.storeKey)) {
        font_size = this.props.store.getItem(this.props.storeKey);
      } else {
        font_size = this.state.font_size;
      }
      return parseInt(font_size, 10);
    }
  }, {
    key: "toggle",
    value: function toggle(type) {
      var new_font_size = this.getTextSize();
      switch (type) {
        case "increase":
          new_font_size += this.props.step;
          break;
        case "decrease":
          new_font_size -= this.props.step;
          break;
        default:
          new_font_size = this.props.default;
          break;
      }
      this.setState({ font_size: new_font_size });
      this.props.store.setItem(this.props.storeKey, new_font_size);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.store && this.props.store.getItem(this.props.storeKey)) {
        this.setState({
          font_size: this.props.store.getItem(this.props.storeKey)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var font_size = this.getTextSize();
      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "button",
          {
            disabled: font_size <= this.props.min,
            className: styles.dot_button,
            onClick: function onClick(event) {
              return _this2.toggle("decrease");
            }
          },
          "-a"
        ),
        React.createElement(
          "button",
          {
            className: styles.dot_button,
            onClick: function onClick(event) {
              return _this2.toggle("default");
            }
          },
          "a"
        ),
        React.createElement(
          "button",
          {
            disabled: font_size >= this.props.max,
            className: styles.dot_button,
            onClick: function onClick(event) {
              return _this2.toggle("increase");
            }
          },
          "+a"
        ),
        React.createElement(
          "style",
          null,
          ("html { font-size: " + font_size + this.props.suffix + " }").trim()
        )
      );
    }
  }]);
  return SwitchTextSize;
}(Component);

SwitchTextSize.propTypes = {
  default: PropTypes.number,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  suffix: PropTypes.string,
  store: PropTypes.object,
  storeKey: PropTypes.string
};

SwitchTextSize.defaultProps = {
  default: 100,
  step: 20,
  min: 60,
  max: 180,
  suffix: "%",
  store: localStorage,
  storeKey: "SwitchTextSize"
};

export default SwitchTextSize;
//# sourceMappingURL=index.es.js.map
